import $http from '@/config/request';

//课程信息
export const getCourseDetailApi = params => {
  return $http.post('/shuangshi/course/courseDetail',params);
}

//课程目录
export const getCourseCatalogApi = params => {
  return $http.post('/shuangshi/course/courseCatalog',params);
}

//课程详情
export const getChapterDetailApi = params => {
  return $http.post('/shuangshi/course/chapterDetail',params);
}

//标记知识点
export const signPointApi = params => {
  return $http.post('/shuangshi/course/signPoint',params);
}

//资料包下载
export const chapterRarDownApi = params => {
  return $http.post('/shuangshi/course/chapterRarDown',params);
}


// //知识点列表
export const getPointListApi = params => {
  return $http.post('/shuangshi/course/getPointList', params);
};

// //删除知识点
export const deletePointApi = params => {
  return $http.post('/shuangshi/course/deletePoint', params);
};

// //标记知识点
export const markPoint = params => {
  return $http.post('/shuangshi/course/signPoint', params);
};


